import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'
import { useQuery, UseQueryResult, UseMutationResult, useQueryClient, useMutation } from '@tanstack/react-query'

export const useGetServiceClassifications = (): UseQueryResult<ServiceClassificationResponseType[]> => {
  const { getServiceClassifications } = useVendorsApiClient()

  return useQuery<ServiceClassificationResponseType[]>({
    queryKey: ['get-service-classifications'],
    queryFn: () => getServiceClassifications(),
    refetchOnWindowFocus: false
  })
}

export const useGetVendorsServiceClassifications = (
  vendorId: string
): UseQueryResult<VendorServiceClassification[]> => {
  const { getServiceClassificationsByVendorId } = useVendorsApiClient()

  return useQuery<VendorServiceClassification[]>({
    queryKey: ['get-service-classifications-by-vendor-id', vendorId],
    queryFn: () => getServiceClassificationsByVendorId(vendorId),
    enabled: vendorId !== '',
    refetchOnWindowFocus: false
  })
}

export const useSetServiceClassification = (vendorId: string): UseMutationResult<unknown, unknown, string, unknown> => {
  const { setServiceClassificationForVendorId } = useVendorsApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (serviceClassificationId: string) => setServiceClassificationForVendorId(vendorId, serviceClassificationId),
    onMutate: (serviceClassificationId) => {
      queryClient.setQueryData(
        ['get-service-classifications-by-vendor-id', vendorId],
        (oldData: VendorServiceClassification[] = []): VendorServiceClassification[] => {
          return [
            ...oldData,
            {
              id: '',
              serviceClassificationId: serviceClassificationId
            }
          ]
        }
      )
    }
  })
}

export const useDeleteServiceClassification = (
  vendorId: string
): UseMutationResult<unknown, unknown, string, unknown> => {
  const { deleteServiceClassificationForVendorId } = useVendorsApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (serviceClassificationId: string) => deleteServiceClassificationForVendorId(vendorId, serviceClassificationId),
    onMutate: (serviceClassificationId) => {
      queryClient.setQueryData(
        ['get-service-classifications-by-vendor-id', vendorId],
        (oldData: VendorServiceClassification[] = []): VendorServiceClassification[] => {
          return oldData.filter((item) => item.serviceClassificationId !== serviceClassificationId)
        }
      )
    }
  })
}
